import {IFormulaNode} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaDefinitions';
import {ICellIOContext} from '@mintdata-wsp/common/controllers/spreadsheet/formula/operations/eval/CellIOContext';
import {SlotDependencies} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {IValue} from '@mintdata/mint-kit/api/types/Value';

export class EvalFormulaResult
{
    constructor(public readonly value:IValue,
                public readonly rootNode:IFormulaNode,
                public readonly dependencies:SlotDependencies,
                public readonly cellIO:ICellIOContext)
    {
    }
}
